import UiAdapter from 'Engine/base/ui/uiAdapter/BaseUiAdapter';
import eStateTypes from '../../enums/eStateTypes';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import EntryPoint from 'Engine/EntryPoint';
import eEventTypes from '../../enums/eEventTypes';

export default class UiAdapterExtended extends UiAdapter {
  addListeners() {
    super.addListeners();
    GlobalDispatcher.add(eEventTypes.EET_COMBINATION_PLAYING, this._onCombinationPlaying, this);
  }

  _onCombinationPlaying() {
    this.ControllerUi.setWin(EntryPoint.GameModel.currentWin);
  }

  initExtraStateHandlers() {
    super.initExtraStateHandlers()
    this.extraStateHandlers = {
      [eStateTypes.EST_FREE_SPINS_ADD]: () => {
        this.hideUi();
      },
      default: () => {
      }
    };
  }
}
